module.exports = __webpack_public_path__ + "img/b99d0228f4f741803aca910f7226801c.png";